<template>
	<section class="d-flex w-100">

		<div class="d-flex flex-column" id="questions">

			<div class="row header-emotivi mb-3 justify-content-around align-items-end">
				<div class="col">
					<h1>FAQ</h1>
				</div>
			</div>

			
			<div class="flex-grow-1 overflow-hidden d-flex">

				<div class="card card-no-margin">
					<div class="row">
						<div class="col-12 col-md-4">
							<h4>{{ questions_total }} questions</h4>
						</div>
						<div class="col-12 col-md-8">
							<div class="d-flex justify-content-end align-items-end mb-3" >

								<button class="btn btn-sm btn-primary form-group mr-4" @click="editQuestion()">
									<icon width="16" height="16" name="plus" color="white" />
									Ajouter
								</button>

								<m-form-select
									:width="300"
									class="no-form-control"
									label="Filter par catégorie"
									label-position="top"
									:name="$Utils.randomstring('filterCategory')"
									v-model="filterCategory"
									:items="$store.state.items_fa_categories"
									@input="loadQuestions"
								/>
								<m-form-text
									class="ml-3 no-form-control"
									label="Rechercher"
									label-position="top"
									v-model="filterText"
									name="search"
									autocomplete
									@input="loadQuestions"
								/>
							</div>
						</div>	
					</div>

					<!--m-list
						ref="questionslist"
						:dynamic="true"
						:items="questions"
						item-value="or_id"
						:item-height="30"
						:limit="questions_limit"
						:skip="questions_skip"
						:total="questions_total"
						:bgstrip="true"
						@changerange="questionsChangeRange"
						@itemclick="editQuestion"
					-->
					<m-list
						ref="questionslist"
						:dynamic="true"
						:items="questions"
						item-value="or_id"
						:item-height="30"
						:bgstrip="true"
						@itemclick="editQuestion"
					>
						<template v-slot:ths="{}">
							<th>
								<span class="pointer">Question</span>
							</th>
							<th class="text-center" style="width: 200px">
								<span class="pointer">Catégorie</span>
							</th>
							<th class="text-center" style="width: 120px">
								<span class="pointer">Mis à jour le</span>
							</th>
							<th style="width: 60px">
	
							</th>
						</template>
						<template v-slot:tds="{ item }">	
							<td>
								{{ item.fa_question }}
							</td>
							<td class="text-center" style="width: 200px">
								{{ getQuestionCategory(item.fa_category) }}
							</td>
							<td class="text-center" style="width: 120px">
								{{ $moment(item.updatedAt).format("DD/MM/YYYY HH[:]mm") }}
							</td>
							<td class="text-center" style="width: 60px">
								<div @click="(event) => deleteQuestion(event, item)">
									<icon width="20" height="20" name="trash-alt" color="black" />
								</div>
							</td>
						</template>
					</m-list>
	
					<faq-win-edit :row_fa_p="itemSelected" v-model="dialog" @reload="loadQuestions" />
					<m-confirm-dialog
						v-model="dialogConfirm"
						text="Supprimer cette question ?"
						title="Confirmation de suppression"
						@canceled="cancelDeleteQuestion"
						@confirmed="confirmDeleteQuestion"
					/>
				</div>

			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "faq",
	components: { },
	data() {
		return {
			questions: [],
			questions_total: 0,
			questions_limit: 50,
			questions_skip: 0,
			sortOrder: "asc",
			sortFields: [],
			row_en: {},
			filterText: "",
			filterCategory: "",
			itemSelected: {},
			dialog: false,
			dialogConfirm: false
		};
	},

	watch: {

	},

	async mounted() {

		let id = parseInt(this.$route.params.fa_id);

		if (id) {
			this.itemSelected.fa_id = id;
			this.dialog = true;
		}

		this.loadQuestions();
	},

	computed: {},

	methods: {

		sortItems(fields) {
			if (fields.length && this.sortFields.length && fields[0] == this.sortFields[0]) {
				this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
			}
			this.sortFields = fields;
			this.loadQuestions();
		},

		getQuestionCategory(value) {
			const result = this.$store.state.items_fa_categories.find(status => status.value === value);
			return result ? result.text : "???";
		},

		async loadQuestions() {

			let params = {
				skip: this.questions_skip,
				limit: this.questions_limit
			};

			if(this.filterText){
				params.search = this.filterText;
			}

			if(this.filterCategory !== undefined){
				params.category = this.filterCategory;
			}

			this.cancelAxiosLoadCancellations && this.cancelAxiosLoadCancellations();

			let response = await this.$axios.get(`${this.$config.server_url}/extranet/2.0/faq`, {
				params,
				cancelToken: new this.$axios.CancelToken(c => {
					this.cancelAxiosLoadCancellations = c;
				})
			});

			if(!response || !response.data){
				return;
			}

			this.questions = response.data.data;
			this.questions_total = response.data.meta.total;
		},

		questionsChangeRange(skip) {
			this.questions_skip = skip;
			this.loadQuestions();
		},

		editQuestion(item) {
			this.itemSelected = item || {
				fa_id: undefined,
				fa_question: "",
				fa_answer: "",
				fa_category: 0
			};
			this.dialog = true;
		},

		deleteQuestion(event, item) {
			event.stopPropagation();
			this.itemSelected = item;
			this.dialogConfirm = true;
		},

		cancelDeleteQuestion() {
			this.dialogConfirm = false
		},

		async confirmDeleteQuestion() {

			this.cancelAxiosLoadCancellations && this.cancelAxiosLoadCancellations();
			await this.$axios.delete(`${this.$config.server_url}/extranet/2.0/faq/${this.itemSelected.fa_id}`, {
				cancelToken: new this.$axios.CancelToken(c => {
					this.cancelAxiosLoadCancellations = c;
				})
			});
			this.loadQuestions();
			this.dialogConfirm = false;
		}
  }
};
</script>

<style lang="scss">
@import "../scss/styles.scss";

.label-new {
	position: absolute;
	right: -6px;
	top: 0px;
	width: 6px;
	height: 6px;
	background-color: #f00;
	border-radius: 3px;
}

.no-form-control {

	margin-top: 0 !important;

	input[name="search"] {
		margin-bottom: 0 !important;
	}
}
</style>
